import React, { useState, useEffect } from "react";
import axios from "axios";

const Form = (props) => {
  const [toEmail, setToEmail] = useState('');		 
  useEffect(() => {				
	setToEmail(`${process.env.REACT_APP_EMAIL_ADDRESS}`);		 
  },[]); 
  
  const [formData, setFormData] = useState({
    username: "",
    email: "",
	phone: "",
	subject: "",
    message: "",
	toemail: toEmail,
  });
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [errorSubmitted, setErrorSubmitted] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [successMessage, setSuccessMessage] = useState('');

  // Handle form data changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  // Handle form submission  
  const handleSubmit = async (event) => {
	  event.preventDefault();	  
	  try {
		 await axios({
              method: "post",
              url: `${process.env.PUBLIC_URL}/getApiSubscribe.php`,
              data: formData,
              headers: { "Content-Type": "multipart/form-data" },
              }).then(function (response) {               
			    setFormData({
					username: "",
					email: "",
					phone: "",
					subject: "",
					message: "",
					toemail: toEmail,					
				  });
			    setSuccessMessage(response.data.message);
				setFormSubmitted(true);               
            }).catch(function (error) {
				setErrorSubmitted(true);                              
				setErrorMessage('error is '+ error.msg);
            });		
		
	  } catch (error) {
		console.error("ERROR:-"+error);		
	  }
	};
	
	function ErrorMessage(props) {
	  return (
		<div className="error-message alert alert-warning">
		  <p>{props.message}</p>
		</div>
	  );
	}
	
	function SuccessMessage(props) {
		  return (
			<div className="success-message alert alert-success">
			  <p>{props.message}</p>
			</div>
		  );
		}

	 useEffect(() => {
		// when the component is mounted, the alert is displayed for 3 seconds
		setTimeout(() => {
		  setFormSubmitted(false);
		  setErrorSubmitted(false); 
		}, 20000);
	  });  

  return (
   		<>		
		{formSubmitted && <SuccessMessage message={successMessage} />}
		{errorSubmitted && <ErrorMessage message={errorMessage} />}
		
		<form  className="" role="search" method="post" onSubmit={handleSubmit}>
			<div className="input-group">				
				<input
					  type="email"
					  required
					  className="form-control" 
					  name="email"
					  placeholder="ENTER YOUR EMAIL"
					  value={formData.email}
					  onChange={handleInputChange}
					/>
				
				<span className="input-group-btn">
					<input type="hidden" id="toemail" name="toemail" value={toEmail} />
					<button type="submit" className="site-button"><i className="fa fa-paper-plane-o"></i></button>
				</span>
			</div>
		</form>
 	 </> 
  );
};
export default Form;